import { Lightning, ShieldCheck, Star } from '@phosphor-icons/react';
import cn from 'classnames';

import { CMSSocialProof } from '@/interfaces/cms';

const cssClassName = 'c-SocialProofs';

const iconNamesToPhosphorIcon = {
  'shield-check': ShieldCheck,
  lightning: Lightning,
  star: Star,
};

type Props = CMSSocialProof;

export const SocialProof = ({
  icon,
  textInsteadOfIcon,
  iconOrLabel,
  text,
}: Props) => {
  const IconComponent = icon && iconNamesToPhosphorIcon[icon];

  return (
    <div className={`${cssClassName}__item`}>
      {(IconComponent || textInsteadOfIcon) && (
        <div className={cn(`${cssClassName}__item-icon-wrapper`)}>
          {IconComponent && iconOrLabel === 'icon' && <IconComponent />}
          {textInsteadOfIcon && iconOrLabel === 'label' && (
            <span className={`${cssClassName}__item-icon-text`}>
              {textInsteadOfIcon}
            </span>
          )}
        </div>
      )}

      <span className={`${cssClassName}__item-text`}>{text}</span>
    </div>
  );
};
